import { HALApiService } from './../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { Service } from './base-service'

export const sourceIntegrationService = new Service('/integrations/integration', HALApiService, createItemsData)
export const IIntegrationService = new Service('/integrations/integration', HALApiService, createItemsData)
